import classNames from 'classnames';
import { truncateString } from 'utils/general';

import { TooltipContent } from '@/modules/home';
import { IHome } from '@/modules/home/types';
import { Typography } from '@/shared/components/atoms';
import { CircularBgImage } from '@/shared/components/atoms';
import TippyTooltip from '@/shared/components/atoms/TippyTooltip';

import ColoredArchive from '~/images/shared/ColoredArchive.svg';
import TimerFilled from '~/images/shared/TimerFilled.svg';

const Field: React.FC<{ field: IHome.IField }> = ({ field }) => {
  const fieldStatusBg = {
    active: 'bg-error-80',
    inactive: 'bg-background-neutral-100',
    completed: 'bg-secondary-90',
  };

  return (
    <TippyTooltip padding='p-0' content={<TooltipContent field={field} />}>
      <div
        className={classNames(
          'relative flex h-[68px] w-72 cursor-pointer flex-col items-center justify-center gap-5 rounded-xl',
          fieldStatusBg[field.status]
        )}
      >
        {field.image && (
          <CircularBgImage
            size='sm'
            imageSrc={field.image}
            bgColor='bg-outline-default'
            imageClassName='scale-125'
          />
        )}
        <Typography variant='body1'>
          {truncateString({ text: field.name, length: 6 })}
        </Typography>

        <div className='absolute top-5 left-5 flex items-center gap-1'>
          {field.fieldStatus === 'INACTIVE' && <ColoredArchive />}
          {field.planned && <TimerFilled width='16' height='16' />}
        </div>
      </div>
    </TippyTooltip>
  );
};

export { Field };
